import { FC, useEffect, useState } from 'react';
import { PortingCard } from '../porting-card/porting-card.component';
import { PortingQueries } from 'apis/porting/porting.queries';
import { useParams, useHistory } from 'react-router-dom';
import { injectParams, ONBOARDING } from '../../../constants/paths';
import { Loader } from 'components/shared/loader/loader.component';
import { Heading, TextLink } from '@weave/design-system';
import { PortingData } from '@weave/schema-gen-ts/dist/schemas/phone/porting/porting-data/v1/porting_data_service.pb';
import { Page } from 'components/shared';
import { css } from '@emotion/core';
import { portingCardStyles } from '../porting-card/porting-card.styles';
import { theme } from '@weave/theme';

export const PortingDetail: FC = () => {
  const { id: locationId, portingDataId } =
    useParams<{ id: string; portingDataId: string }>();

  const history = useHistory();

  const [portingDetails, setPortingDetails] = useState<PortingData>();

  const { data, isLoading } = PortingQueries.useGetPortingDetails(
    {
      portingDataId,
    },
    {
      select: (response) => response.portingData,
      refetchOnMount: true,
      staleTime: 0,
    }
  );

  const handleBack = () => {
    history.push(injectParams(ONBOARDING.portingV2, { id: locationId }));
  };

  const portingRequest = portingDetails?.portingRequests?.[0];

  useEffect(() => {
    if (data) {
      setPortingDetails(data);
    }
  }, [data]);

  return (
    <Page
      title="Port Order:"
      subtitle={portingRequest?.portOrderNumber ?? ''}
      containerStyle={containerStyles}
    >
      <TextLink onClick={handleBack} css={{ maxWidth: 'max-content' }}>
        {'< Back'}
      </TextLink>

      {isLoading && (
        <div className={portingCardStyles.loading}>
          <Loader />
        </div>
      )}

      {!isLoading && !portingRequest && (
        <Heading level={3}>No porting data found</Heading>
      )}

      {!!portingDetails && (
        <PortingCard
          port={portingDetails}
          onBack={handleBack}
          setPortingDetails={setPortingDetails}
        />
      )}
    </Page>
  );
};

const containerStyles = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
});
